import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const SectionLoader = ({ minHeight = 120 }) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Box
      sx={{
        display:        "flex",
        alignItems:     "center",
        justifyContent: "center",
        minHeight,
      }}
    >
      <CircularProgress size={24} sx={{ color: t.accent }} />
    </Box>
  );
};

export default SectionLoader;
